import React from 'react';

import dayjs from '~/timeInit';

import { Chip } from '@mui/material';

interface Props {
  expiresAt: string;
}

export default function PromoStatusChip({ expiresAt }: Props) {
  const expiry = dayjs(expiresAt);
  if (!expiresAt || !expiry.isValid()) {
    return <Chip label="Unknown expiry" size="small" variant="outlined" />;
  }

  const isExpired = !expiry.isAfter(dayjs());
  return (
    <Chip
      label={isExpired ? 'Expired' : 'Active'}
      size="small"
      color={isExpired ? 'error' : 'success'}
      variant="outlined"
    />
  );
}
